import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE;


const RevisarOrden = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [orden, setOrden] = useState(null);

  useEffect(() => {
    const obtenerOrden = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/pedidos/${id}`);
        if (!res.ok) throw new Error('No se encontró la orden');
        const data = await res.json();
        setOrden(data);
      } catch (err) {
        alert('No se pudo cargar la orden');
      }
    };
    obtenerOrden();
  }, [id]);

  const actualizarEstado = async (nuevoEstado) => {
    try {
      const res = await fetch(`${API_BASE}/api/pedidos/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ estado: nuevoEstado }),
      });
      if (!res.ok) throw new Error('No se pudo actualizar el estado');
      setOrden(prev => ({ ...prev, estado: nuevoEstado }));
      alert(`Pedido actualizado a "${nuevoEstado}"`);
      navigate('/ordenes');
    } catch (err) {
      alert('Error al actualizar el pedido');
    }
  };

  // Registrar la ruta y pasar pedido a enRuta
  const enviarARuta = async () => {
    try {
      await fetch(`${API_BASE}/api/rutas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          clienteId: orden.usuarioId || orden.uid,
          boleta: orden.boleta,
          fechaRuta: new Date(),
        }),
      });
      await actualizarEstado('enRuta');
    } catch (err) {
      alert('Error al enviar a ruta');
    }
  };

  // Si solo quieres que "En Proceso" con dirección pase a ruta, agrega esa lógica aquí:
 /* const aprobarPedido = async () => {
    if (orden.total >= 1000) {
      await enviarARuta();
    } else {
      await actualizarEstado('enProceso');
    }
  };
*/
  if (!orden)
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-gray-500 text-lg">Cargando orden...</p>
      </div>
    );



  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md mt-10">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">
        Revisar Orden <span className="text-blue-600">Boleta No. #{orden.boleta}</span>
      </h1>

      <div className="mb-6 space-y-2">
        <p className="text-gray-700"><span className="font-semibold">Email:</span> {orden.email || 'No disponible'}</p>
        <p className="text-gray-700"><span className="font-semibold">Boleta:</span> {orden.boleta}</p>
        {orden.direccionEntrega && (
          <p className="text-gray-700"><span className="font-semibold">Dirección:</span> {orden.direccionEntrega}</p>
        )}
        <p className="text-gray-700">
          <span className="font-semibold">Estado:</span>{' '}
          <span className={`font-bold ${orden.estado === 'Pendiente' ? 'text-yellow-600' : 'text-blue-600'}`}>
            {orden.estado}
          </span>
        </p>
        <p className="text-gray-700">
          <span className="font-semibold">Total:</span>{' '}
          <span className="text-green-600 font-bold">Q{Number(orden.total).toFixed(2)}</span>
        </p>
      </div>

      <h2 className="text-2xl font-semibold mb-4 text-gray-800">Productos</h2>
      <ul className="space-y-4">
        {orden.pedido?.map((producto, index) => (
          <li
            key={index}
            className="flex items-center border border-gray-200 rounded-lg p-4 shadow-sm"
          >
            <img
              src={producto.imagen ? `${API_BASE}/uploads/${producto.imagen}` : '/nodisponible.png'}
              alt={producto.nombre}
              className="w-20 h-20 object-cover rounded-md mr-6"
            />
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900">{producto.nombre}</h3>
              <p className="text-gray-600">Marca: {producto.marca}</p>
              <p className="text-gray-600">Presentación: {producto.presentacion}</p>
              {producto.descripcion && (
                <p className="text-gray-600">Descripción: {producto.descripcion}</p>
              )}
              <p className="text-gray-600">Cantidad: {producto.cantidad}</p>
              <p className="text-gray-600">
                Subtotal:{' '}
                <span className="font-semibold text-green-600">
                  Q{producto.subtotal.toFixed(2)}
                </span>
              </p>
            </div>
          </li>
        ))}
      </ul>

      {/* Imagen de la boleta */}
      
      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Comprobante de pago</h2>
        <img
          src={`${API_BASE}/uploads/${orden.imagen}`}
          alt="Comprobante"
          className="max-w-sm rounded-md border shadow"
          style={{ maxHeight: 300, objectFit: 'contain' }}
        />
      </div>
      

      <div className="mt-8 space-y-3">
        {/* PENDIENTE */}
        {orden.estado === 'Pendiente' && (
          orden.total >= 1000 ? (
            <button
              onClick={enviarARuta}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-md"
            >
              Enviar a Ruta
            </button>
          ) : (
            <button
              onClick={() => actualizarEstado('enProceso')}
              className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-md"
            >
              Aprobar pedido
            </button>
          )
        )}

        {/* EN PROCESO */}
        {orden.estado === 'enProceso' && (
          !orden.direccionEntrega ? (
            <button
              onClick={() => actualizarEstado('Entregado')}
              className="bg-orange-600 hover:bg-orange-700 text-white font-semibold px-6 py-3 rounded-md"
            >
              Entregar al Cliente
            </button>
          ) : (
            <button
              onClick={enviarARuta}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-md"
            >
              Enviar a Ruta
            </button>
          )
        )}

      </div>
    </div>
  );
};

export default RevisarOrden;
